import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { get } from 'lodash';
import { WithRequired } from '@logz-build/typescript';
import { InlineFlex } from '../../containers/Flex/Flex.component';
import { ITagProps } from '../Tag.component';

export const Container = styled(InlineFlex)<WithRequired<ITagProps, 'variant'>>`
  align-items: center;
  padding: 0 5px;
  max-width: fit-content;
  transition: background-color 0.1s ease-in-out;

  ${({ variant, theme: { tag } }) => tag.variants[variant]}

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}


  ${({ background, theme }) => {
    return (
      background &&
      css`
        background: ${get(theme.colors, background)};
      `
    );
  }}
  ${space}
`;

export const TagContainer: React.FC<PropsWithChildren<WithRequired<ITagProps, 'variant'>>> = ({
  children,
  ...props
}) => {
  return <Container {...props}>{children}</Container>;
};
